export const TRUST_LINE_INFINITE_VALUE = '10000000000000';
